import React, { useState, useRef } from "react";
import Container from "@material-ui/core/Container";
import ReactPlayer from "react-player";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import screenful from "screenfull";
import Controls from "./controller";
import Hls from 'hls.js';
// import socketIOClient from "socket.io-client";
import { io } from "socket.io-client";

import {
  COUNTRYCODE,
  PARTNER_ID,
  USERID,
  CONTINUE_WATCHING,
  HLSJSVERSION,
} from "../../url";
import { FlareSharp } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  playerWrapper: {
    width: "100%",
    position: "relative",
    // "&:hover": {
    //   "& $controlsWrapper": {
    //     visibility: "visible",
    //   },
    // },
  },

  controlsWrapper: {
    visibility: "hidden",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "98%",
    bottom: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  topControls: {
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(2),
  },
  middleControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  bottomWrapper: {
    display: "flex",
    flexDirection: "column",

    //background: "rgba(0,0,0,0.6)",
    //height: 60,
    padding: theme.spacing(2),
  },

  bottomControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    //height:40,
  },

  button: {
    margin: theme.spacing(1),
  },
  controlIcons: {
    color: "#777",

    fontSize: 50,
    transform: "scale(0.9)",
    "&:hover": {
      color: "#fff",
      transform: "scale(1)",
    },
  },

  bottomIcons: {
    color: "#999",
    "&:hover": {
      color: "#fff",
    },
  },

  volumeSlider: {
    width: 100,
  },
}));

const format = (seconds) => {
  if (isNaN(seconds)) {
    return `00:00`;
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};

let count = 0;

function VideoPlayerComponent(props) {
  const classes = useStyles();
  const [livecount, setLiveCount] = useState("");
  const [timeDisplayFormat, setTimeDisplayFormat] = React.useState("normal");
  const [showSpinner, setshowSpinner] = React.useState(true);
  //const [percentPlayed, setpercentPlayed] = React.useState(0);
  // let [captures, setcaptures] = React.useState([]);
  // const [playerdata, setplayerdata] = React.useState();
  // const [url, seturl] = useState('');
  const [showvolumeControl, setIsShowVolumeSlider] = useState(false);
  const [state, setState] = useState({
    isAdsended: false,
    url: undefined,
    urlcookies: undefined,
    isAdsShowing: undefined,
    seekProcess: false,
    pip: false,
    fullScreen: false,
    playing: true,
    controls: false,
    light: false,
    subtitleDisplays: false,
    muted: false,
    played: 0,
    duration: 0,
    playedsec: 0,
    timeDurationls: 0,
    playbackRate: 1.0,
    volume: 1,
    loop: false,
    seeking: false,
    hlsPlayerdata: {},
    videoaudiohas: [],
    framerate: [],
    episodes: [],
    recommend: [],
    mainsubtitledata: [],
    subtitleTracksdata: [],
    subtitleTracksSelected: "",
    currentaudioTrack: "",
    levellsmain: "",
    errorAlert: false,
    errorMessage: null
  });

  const [mileStone, setMilestone] = useState({
    m1: false,
    m2: false,
    m3: false,
    m4: false,
    m5: false
  })

  const playerRef = useRef(null);
  const playerContainerRef = useRef(null);
  const controlsRef = useRef(null);
  const {
    isAdsended,
    url,
    urlcookies,
    isAdsShowing,
    playing,
    fullScreen,
    controls,
    light,
    muted,
    loop,
    playbackRate,
    pip,
    played,
    playedsec,
    volume,
    framerate,
    episodes,
    recommend,
    subtitleDisplays,
    videoaudiohas,
    currentaudioTrack,
    subtitleTracksdata,
    subtitleTracksSelected,
    levellsmain,
    seekProcess
  } = state;
  React.useEffect(() => {
    // alert("000"+props.videoUrl)
    window.addEventListener("keydown", handleKeypress);
    if (props.setConfig) {
      if (props.adv_info !== undefined && props.adv_info !== null && props.adv_info) {
        // let adsdownloadUrl = "?Key-Pair-Id=" + props.adv_info.aws["CloudFront-Key-Pair-Id"] + "&Policy=" + props.adv_info.aws["CloudFront-Policy"] + "&Signature=" + props.adv_info.aws["CloudFront-Signature"];
        let AdsUrl = props.adv_info

        //page reload case
        //  
        if (performance.navigation.type === performance.navigation.TYPE_RELOAD && isAdsShowing === undefined) {
          setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true })
        }
        if (props.medium === true && isAdsShowing === undefined) {
          //  
          setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true, playing: true, });
        }
        else {
          //  
          let userAgent = navigator.userAgent;
          let browserName;
          // alert('okay')
          if (isAdsShowing === undefined) {
            if (userAgent.match(/chrome|chromium|crios/i)) {
              browserName = "chrome";
              setState({ ...state, url: AdsUrl, isAdsShowing: true })
            }
            else if (userAgent.match(/firefox|fxios/i)) {
              browserName = "firefox";
              setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true })
            }
            else if (userAgent.match(/safari/i)) {
              browserName = "safari";
              setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true })
            }
            else if (userAgent.match(/opr\//i)) {
              browserName = "opera";
              setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: true })
            }
            else if (userAgent.match(/edg/i)) {
              browserName = "edge";
              setState({ ...state, url: AdsUrl, isAdsShowing: true, muted: false })
            }
            else {
              browserName = "No browser detection";
            }
          }
          else {
            // alert(' tu to gayo')
          }
        }
      }
      else {
        let voddownloadUrl = "?Key-Pair-Id=" + props.aws["CloudFront-Key-Pair-Id"] + "&Policy=" + props.aws["CloudFront-Policy"] + "&Signature=" + props.aws["CloudFront-Signature"];
        let vodUrl = props.videoUrl
        //page reload case
        if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
          setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: true })
        } else {
          let userAgent = navigator.userAgent;
          let browserName;

          if (userAgent.match(/chrome|chromium|crios/i)) {
            browserName = "chrome";
            setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: false, playing: true })
          }
          else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "firefox";
            setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: true, playing: true })
          }
          else if (userAgent.match(/safari/i)) {
            browserName = "safari";
            setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: true, playing: true })
          }
          else if (userAgent.match(/opr\//i)) {
            browserName = "opera";
            setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: true, playing: true })
          }
          else if (userAgent.match(/edg/i)) {
            browserName = "edge";
            setState({ ...state, url: vodUrl, urlcookies: voddownloadUrl, isAdsShowing: false, muted: false, playing: true })
          }
          else {
            browserName = "No browser detection";
          }
        }
      }
      //window.onpopstate = (e) => handlepopstate(e);
      let lastUrl = window.location.href;
      new MutationObserver(() => {
        const url = window.location.href;
        if (url !== lastUrl) {
          let videoPercentPlayed = localStorage.getItem("reactplayer.videoPercentPlayed")
          handlepopstate(videoPercentPlayed);
          lastUrl = url;
        }
      }).observe(document, { subtree: true, childList: true });
    } else {
      //const socket =  socketIOClient(ENDPOINT)
      if (!props.setConfig) {
        let liveUrl = props.videoUrl
        setState({ ...state, url: liveUrl, muted: false })

        // const socket = io("http://stg-api.planetcast.in:8086");

        // client-side
        // socket.on("status", data => {
        //   setLiveCount(data.count);
        // });

        //  
        // const ENDPOINT = "http://stg-api.planetcast.in:8086"
        // const socket = socketIOClient(ENDPOINT)
        // socket.on("status", data => {
        //   setLiveCount(data.count);
        // });
      }
    }


    return () => {
      if (!props.setConfig) {
      }
      window.removeEventListener("keydown", handleKeypress);
    };

  }, [subtitleTracksdata]);
  // React.useEffect(() => {
  //   window.addEventListener("keydown", handleKeypress);
  //   if (props.setConfig) {
  //     //window.onpopstate = (e) => handlepopstate(e);
  //     let lastUrl = window.location.href;
  //     new MutationObserver(() => {
  //       const url = window.location.href;
  //       if (url !== lastUrl) {
  //         let videoPercentPlayed = localStorage.getItem("reactplayer.videoPercentPlayed")
  //         handlepopstate(videoPercentPlayed);
  //         lastUrl = url;
  //       }
  //     }).observe(document, { subtree: true, childList: true });
  //   }

  //   if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
  //     setState({ ...state, muted: true, playing: true });
  //   } else {
  //   }
  //   return () => {
  //     window.removeEventListener("keydown", handleKeypress);
  //   };



  // }, [subtitleTracksdata]);

  // const hlsPlayer = ()=>{
  //   let hlsPlayer =  playerRef.current.getInternalPlayer('hls')
  // }

  const handleKeypress = (event) => {
    if (event.keyCode === 70) {
      screenful.toggle(playerContainerRef.current);
    }
  };

  const handlePlayPause = () => {
    setState({ ...state, playing: !state.playing });
    document.querySelector('#playercontainer_wrapper').classList.remove('show');
  };

  const handlepip = () => {
    setState({ ...state, pip: !state.pip });
  };

  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
  };

  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
  };

  const handelstart = () => {
    controlsRef.current.style.visibility = "hidden";
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let currentaudioTrack = hlsPlayer.audioTrack;
    if (props.setConfig) {
      window._paq.push([
        "trackEvent",
        "Video Playback",
        "PLAYBACK_STARTED",
        props.tittle,
      ]);
    }
    // setState({ ...state, })
    setState({
      ...state,
      subtitleTracksdata: hlsPlayer.subtitleTracks,
      currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: hlsPlayer.subtitleTrack,
    });
  };

  const handelReady = () => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let levels = hlsPlayer.levels;
    let languagehas = hlsPlayer.audioTrackController.tracks;
    let levellsmain = hlsPlayer.currentLevel;
    let levelsreverse = levels;
    setState({
      ...state,
      videoaudiohas: languagehas,
      framerate: levelsreverse,
      levellsmain: levellsmain
    });
    playerRef.current.seekTo(props.playedDuration / 1000);
  };

  const downloadUrl =
    "?Key-Pair-Id=" +
    props.aws["CloudFront-Key-Pair-Id"] +
    "&Policy=" +
    props.aws["CloudFront-Policy"] +
    "&Signature=" +
    props.aws["CloudFront-Signature"];

  const getContinueWatching = async (currentTimePlay) => {
    let formData = new FormData();
    formData.append("userid", USERID);
    formData.append("countrycode", COUNTRYCODE);
    formData.append("partnerid", PARTNER_ID);
    formData.append("tag", "insert");
    formData.append("duration", Math.floor(currentTimePlay));
    formData.append("entryid", props.entryid);
    await axios.post(CONTINUE_WATCHING, formData, {
      headers: { token: localStorage.getItem("token") },
    });
  }
  const handleContinueWatchingEnded = async (e) => {
    var formData = new FormData();
    formData.append("partnerid", PARTNER_ID);
    formData.append("userid", USERID);
    formData.append("tag", "delete");
    formData.append("entryid", props.entryid);

    await fetch(CONTINUE_WATCHING, {
      method: "POST",
      headers: {
        token: localStorage.getItem("token"),
      },
      body: formData,
    }).then((response) => response.json());
  };

  const handelPercentplayed = (playedsec) => {

    let markers = [10, 25, 50, 75, 90];
    //let videoPercentPlayed = Math.floor((playedsec * 100) / duration);
    let videoPercentPlayed = parseFloat(playedsec / duration) * 100;
    let playesSecMiliSec = playedsec * 1000;
    localStorage.setItem("reactplayer.videoPercentPlayed", Math.floor(videoPercentPlayed))
    //setpercentPlayed(Math.floor(videoPercentPlayed));
    if (!localStorage.getItem("token")) {
      return false;
    }

    if (videoPercentPlayed > markers[0] && !mileStone.m1) {
      setMilestone({ ...mileStone, m1: true });
      getContinueWatching(playesSecMiliSec)
    } else if (videoPercentPlayed > markers[1] && !mileStone.m2) {
      setMilestone({ ...mileStone, m2: true });
      getContinueWatching(playesSecMiliSec)
    } else if (videoPercentPlayed > markers[2] && !mileStone.m3) {
      setMilestone({ ...mileStone, m3: true });
      getContinueWatching(playesSecMiliSec)
    } else if (videoPercentPlayed > markers[3] && !mileStone.m4) {
      setMilestone({ ...mileStone, m4: true });
      getContinueWatching(playesSecMiliSec)
    } else if (videoPercentPlayed > markers[4] && !mileStone.m5) {
      setMilestone({ ...mileStone, m5: true });
      getContinueWatching(playesSecMiliSec)
    }
  };

  const handleProgress = (changeState) => {
    let playedsec = Math.floor(changeState.playedSeconds);
    if (
      (!changeState.played || changeState.played === 0) &&
      changeState.loaded > 0
    ) {
      setshowSpinner(false)
    }

    if (props.setConfig && !isAdsShowing) handelPercentplayed(playedsec);
    //handelPercentplayed(playedsec);
    if (count > 3) {
      controlsRef.current.style.visibility = "hidden";
      count = 0;
    }
    if (controlsRef.current.style.visibility === "visible") {
      count += 1;
    }
    if (!state.seeking) {
      setState({
        ...state,
        ...changeState,
        playedsec
      });
    }
  };

  const handlepopstate = (percentPlayed) => {
    if (props.setConfig && percentPlayed) {
      //let percentPlayed = Math.floor(played * 100);
      let videoName = props.tittle;
      // if (percentPlayed) {
      //   window._paq.push([
      //     "trackEvent",
      //     "Video Playback",
      //     "PLAYBACK_ABANDONED",
      //     videoName,
      //     percentPlayed,
      //   ]);

      //   if (percentPlayed > 25 && percentPlayed < 50) {
      //     window._paq.push([
      //       "trackEvent",
      //       "Video Playback",
      //       "PLAYBACK_WATCHED_25",
      //       videoName,
      //       percentPlayed,
      //     ]);
      //   } else if (percentPlayed > 50 && percentPlayed < 75) {
      //     window._paq.push([
      //       "trackEvent",
      //       "Video Playback",
      //       "PLAYBACK_WATCHED_50",
      //       videoName,
      //       percentPlayed,
      //     ]);
      //   } else if (percentPlayed > 75 && percentPlayed < 90) {
      //     window._paq.push([
      //       "trackEvent",
      //       "Video Playback",
      //       "PLAYBACK_WATCHED_75",
      //       videoName,
      //       percentPlayed,
      //     ]);
      //   } else if (percentPlayed > 90 && percentPlayed < 95) {
      //     window._paq.push([
      //       "trackEvent",
      //       "Video Playback",
      //       "PLAYBACK_WATCHED_90",
      //       videoName,
      //       percentPlayed,
      //     ]);
      //   } else if (percentPlayed > 95 && percentPlayed < 100) {
      //     window._paq.push([
      //       "trackEvent",
      //       "Video Playback",
      //       "PLAYBACK_WATCHED_95",
      //       videoName,
      //       percentPlayed,
      //     ]);
      //   }
      // }
    }
  };

  const handleSeekChange = (e, newValue) => {
    setState({ ...state, played: parseFloat(newValue / 100) });
  };

  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };

  const handleSeekMouseUp = (e, newValue) => {
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue / 100, "fraction");
  };

  const handleDuration = (duration) => {
    setState({ ...state, duration: duration });
  };

  const handleVolumeSeekDown = (e, newValue) => {
    setState({ ...state, seeking: false, volume: parseFloat(newValue / 100) });
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handleEnded = (e) => {
    if (props.setConfig) {
      if (isAdsShowing === false) {
        handleContinueWatchingEnded()
      }
      // next vod\
      //  
      if (props.aws !== undefined && props.videoUrl !== undefined && isAdsShowing !== false) {
        //  
        let voddownloadUrl = "?Key-Pair-Id=" + props.aws["CloudFront-Key-Pair-Id"] + "&Policy=" + props.aws["CloudFront-Policy"] + "&Signature=" + props.aws["CloudFront-Signature"];
        let vodUrl = props.videoUrl
        setState({
          ...state,
          url: props.videoUrl,
          isAdsShowing: false,
          isAdsended: true,
          playing: true,
          urlcookies: voddownloadUrl,
          isAdsended: true
        });
        // setState({ ...state, url: props.videoUrl, urlcookies: voddownloadUrl, isAdsShowing: false, isAdsended: true })
        return false

      }
      if (props.nextVod !== null && props.nextVod !== undefined && isAdsShowing !== true) {
        //  
        let name = props.nextVod.title
        let namestring = name.replace(/\s+/g, '')
        let entryid = props.nextVod.entryid
        let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`
        window.location.assign(url)
      }
      else if (props.episodes.length > 0) {
        let firstData = props.episodes !== null && props.episodes !== undefined && props.episodes.length > 0 && props.episodes[0].search_tag !== null && props.episodes[0].search_tag !== undefined ? props.episodes[0].search_tag[0] : {}
        let name = firstData.name
        let namestring = name.replace(/\s+/g, '')
        let entryid = firstData.entryid
        let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`
        window.location.assign(url)
        //alert('data::'+JSON.stringify(url))
      }
      else if (props.trailer.length > 0) {
        let firstData = props.trailer !== null && props.trailer !== undefined && props.trailer.length > 0 && props.trailer[0] !== null && props.trailer[0] !== undefined ? props.trailer[0] : {}
        let name = firstData.name
        let namestring = name.replace(/\s+/g, '')
        let entryid = firstData.entryid
        let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`
        window.location.assign(url)
      }
      else {
        //alert(props.recommend.length)
        let firstData = props.recommend !== null && props.recommend !== undefined && props.recommend.length > 0 && props.recommend[0] !== null && props.recommend[0] !== undefined ? props.recommend[0] : {}
        let name = firstData.name
        let namestring = name.replace(/\s+/g, '')
        let entryid = firstData.entryid
        let url = `/video/cat/${namestring.toLowerCase()}/${entryid}`
        window.location.assign(url)
      }

      // window._paq.push([
      //   "trackEvent",
      //   "Video Playback",
      //   "PLAYBACK_COMPLETED",
      //   name,
      //   100,
      // ]);
    }
  };

  const toggleFullScreen = () => {
    screenful.toggle(playerContainerRef.current);
    setState({ ...state, fullScreen: !state.fullScreen });
  };

  const handleMouseMove = () => {
    controlsRef.current.style.visibility = "visible";
    //setshowSpinner(false)
    count = 0;
  };

  const hanldeerror = (e, data) => {
    if (data.fatal) {
      controlsRef.current.style.visibility = "visible";
      if (playedsec) {
        // window._paq.push([
        //   "trackEvent",
        //   "Video Playback",
        //   "FATAL_PLAYER_ERROR",
        //   props.tittle,
        //   Math.floor(playedsec),
        // ]);
        setState({
          ...state,
          seekProcess: true,
        });
        setshowSpinner(true)
      }

      setState({
        ...state,
        errorAlert: true,
        errorMessage: data.details
      });

      let hls = playerRef.current.getInternalPlayer("hls");
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          // try to recover network error
          hls.startLoad();
          break;
        case Hls.ErrorTypes.MEDIA_ERROR:
          hls.recoverMediaError();
          break;
        default:
          //cannot recover
          hls.destroy();
          break;
      }
    }
  };

  const handleplay = () => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let subtitleTracks = hlsPlayer.subtitleTracks
    let currentaudioTrack = hlsPlayer.audioTrack;
    let currentsubtitleTrack = hlsPlayer.subtitleTrack
    setState({
      ...state,
      errorAlert: false,
      subtitleTracksdata: subtitleTracks,
      currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: currentsubtitleTrack
    });
    setshowSpinner(false)
  };

  const hanldeMouseLeave = () => {
    state.errorAlert ? controlsRef.current.style.visibility = "visible" : controlsRef.current.style.visibility = "hidden";
    count = 0;
  };

  const handleDisplaysubtitle = (e) => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let target = e.currentTarget;
    for (
      let i = 0;
      i < target.parentElement.parentElement.children.length;
      i++
    ) {
      target.parentElement.parentElement.children[i].classList.remove("active");
    }
    target.parentElement.classList.add("active");
    setState({ ...state, subtitleDisplays: !state.subtitleDisplays });
    // if (subtitleDisplays == true) {
    //   hlsPlayer.subtitleDisplay = true;
    //   hlsPlayer.subtitleTrack = 0;
    // } else {
    //   hlsPlayer.subtitleDisplay = false;
    //   hlsPlayer.subtitleTrack = -1;
    // }
    hlsPlayer.subtitleDisplay = false;
    hlsPlayer.subtitleTrack = -1;

  };

  const handleDisplayFormat = () => {
    setTimeDisplayFormat(
      timeDisplayFormat === "normal" ? "remaining" : "normal"
    );
  };

  const handlePause = (e) => {
    setState({ ...state, playing: false });
  };

  const handleBuffer = (e) => {
    let hlsPlayer = playerRef.current.getInternalPlayer("hls");
    let subtitleTracks = hlsPlayer.subtitleTracks
    let currentaudioTrack = hlsPlayer.audioTrack;
    let currentsubtitleTrack = hlsPlayer.subtitleTrack
    setState({
      ...state, subtitleTracksdata: subtitleTracks, currentaudioTrack: currentaudioTrack,
      subtitleTracksSelected: currentsubtitleTrack
    });
    if (seekProcess) {
      //seek 1 sec
      playerRef.current.seekTo(playerRef.current.getCurrentTime() + 1);
      setshowSpinner(false)
    }
  };

  const handleSeek = (e) => {
    // console.log("seek", e);
  };

  const handlePlaybackRate = (rate) => {
    setState({ ...state, playbackRate: rate });
  };

  const hanldeMute = () => {
    setState({ ...state, muted: !state.muted });
    setIsShowVolumeSlider(!showvolumeControl);
    setTimeout(() => {
      setIsShowVolumeSlider(false);
    }, 6000);
  };

  const handleEnablePIP = () => {
    setState({ ...state, pip: true });
  }

  const handleDisablePIP = () => {
    setState({ ...state, pip: false });
  }

  // //const currentTime = playerRef && playerRef.current ? playerRef.current.getCurrentTime() : "00:00";
  // const videoduration =
  //   playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";
  // const currentTime = playedsec;
  // const elapsedTime =
  //   timeDisplayFormat === "normal"
  //     ? format(currentTime)
  //     : `-${format(duration - currentTime)}`;
  // const totalDuration = format(videoduration);

  const currentTime =
    playerRef && playerRef.current
      ? playerRef.current.getCurrentTime()
      : "00:00";

  const duration =
    playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";
  const elapsedTime =
    timeDisplayFormat == "normal"
      ? format(currentTime)
      : `-${format(duration - currentTime)}`;

  const totalDuration = format(duration);

  const configlive = {
    //maxBufferLength : 300,
    file: {
      hlsOptions: {
        maxBufferLength: 300,
      },
      hlsVersion: HLSJSVERSION,
    },
  };

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  const config = {
    file: {
      forceHLS: !isSafari,
      forceVideo: !isSafari,
      attributes: {
        crossOrigin: "use-credentials",
      },

      hlsOptions: {
        forceHLS: !isSafari,
        debug: true,
        xhrSetup: function (xhr, url) {
          if (props.aws !== undefined) {
            // 
            xhr.withCredentials = true; //send cookies
            xhr.credentials = "include";
            // xhr.open("GET", url + downloadUrl);  //get call params
            // xhr.setRequestHeader(
            //   "Access-Control-Allow-Headers",
            //   "Accept,Origin,Content-Type,X-LS-CORS-Template,X-LS-Auth-Token,X-LS-Auth-User-Token,Content-Type,X-LS-Sync-Result,X-LS-Sequence,token"
            // );
            xhr.setRequestHeader(
              "Access-Control-Allow-Methods",
              "POST, GET, OPTIONS, DELETE"
            );
            xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");
            xhr.setRequestHeader("Access-Control-Allow-Origin", props.domUrl);
          }
        },
      },
      hlsVersion: HLSJSVERSION,
    },
  };
  const checkConfig = () => {
    //  
    if (props.setConfig === true) {
      if (isAdsShowing === true) {
        return {}
      } else {
        return config
      }
    }
    else {
      return configlive
    }
  }

  return (
    <div
      onMouseMove={handleMouseMove}
      onMouseLeave={hanldeMouseLeave}
      ref={playerContainerRef}
      className={classes.playerWrapper}
      id="plyrBx"
    >

      <ReactPlayer
        ref={playerRef}
        className="videoplayerwrapper embed-responsive embed-responsive-16by9"
        url={url}
        // url={props.videoUrl}
        // url={'https://bitmovin-a.akamaihd.net/content/sintel/hls/playlist.m3u8'}
        pip={pip}
        playing={playing}
        controls={controls}
        light={light}
        loop={loop}
        playbackRate={playbackRate}
        volume={volume}
        muted={muted}
        onError={hanldeerror}
        onDuration={handleDuration}
        onPlay={handleplay}
        onProgress={handleProgress}
        onStart={handelstart}
        onReady={handelReady}
        onPause={handlePause}
        onBuffer={handleBuffer}
        onSeek={handleSeek}
        onEnded={handleEnded}
        onEnablePIP={handleEnablePIP}
        onDisablePIP={handleDisablePIP}
        // config={props.setConfig ? isAdsShowing === true ? {} : config : configlive}
        config={isAdsShowing ? {} : props.setConfig ? config : configlive}
      // config={''}
      />
      <Controls
        nextVod={
          props.nextVod
        }
        tittle={props.tittle}
        currentaudioTrack={
          currentaudioTrack !== undefined ? currentaudioTrack : 0
        }
        showSpinner={showSpinner}
        setConfig={props.setConfig}
        levellsmain={levellsmain}
        ref={controlsRef}
        onPlayerRefrence={playerRef}
        onSeek={handleSeekChange}
        onSeekMouseDown={handleSeekMouseDown}
        onSeekMouseUp={handleSeekMouseUp}
        onRewind={handleRewind}
        onPlayPause={handlePlayPause}
        onFastForward={handleFastForward}
        playing={playing}
        fullScreen={fullScreen}
        tikcerdata={props.ticker}
        played={played}
        elapsedTime={elapsedTime}
        totalDuration={totalDuration}
        onError={(e) => hanldeerror(e)}
        onMute={hanldeMute}
        showvolumeControl={showvolumeControl}
        muted={muted}
        onVolumeChange={handleVolumeChange}
        onVolumeSeekDown={handleVolumeSeekDown}
        onChangeDispayFormat={handleDisplayFormat}
        playbackRate={playbackRate}
        onPlaybackRateChange={handlePlaybackRate}
        onToggleFullScreen={toggleFullScreen}
        //onToggleDownload={toggleDownload}
        volume={volume}
        onEnded={handleEnded}
        onPip={handlepip}
        languagedata={videoaudiohas}
        onsubtitleTracks={subtitleTracksdata}
        onFramerate={framerate}
        onsubtitleTracksdisplay={handleDisplaysubtitle}
        subtitleDisplays={subtitleDisplays}
        subtitleTracksSelected={subtitleTracksSelected}
        pip={pip}
        errorAlert={state.errorAlert}
        errorMessage={state.errorMessage}
        livecount={livecount}
        isAdsShowing={isAdsShowing}
      />
    </div>
  );
}
export default VideoPlayerComponent;
